import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TGetHeadcountRequest,
  TGetHeadcountResponse,
} from "./getHeadcount.schema";

export const getHeadcount = (axios: IAxiosInstance) => {
  return async (body: TGetHeadcountRequest) => {
    const response = await axios.noRetry.post<
      ZealApiResponse<TGetHeadcountResponse>
    >("/api/headcount", body);

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Failed to fetch headcount data");
  };
};
